class Logger {
  constructor() {}

  static async send(config = {}) {
    const { baseURL, data, url, empUid } = config;
    const userAgent = window.navigator.userAgent;
    
    fetch(process.env.VUE_APP_LOGGER_URL, {
      method: "POST",
      body: JSON.stringify({
        baseURL,
        data,
        empUid,
        url,
        userAgent,
        env: process.env.NODE_ENV,
      }),
    });
  }
}

export default Logger;
